export default "__VITE_ASSET__CYnqD$7c__"